import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Prompt} from 'react-router-dom';
import LineageEditor from './components/LineageEditor';
import * as A from './store/lineageActions';

class NewLineage extends Component {
  static defaultProps = {
    customTitle: '',
    editMode: false,
    id: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.id || `map-${Date.now()}`,
    };
    this._autosaveTimer = null;
  }

  componentDidMount() {
    this._beforeUnload = (e) => {
      if (this.props.dirty || this.props.saveState === 'saving') {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', this._beforeUnload);
  }

  componentDidUpdate(prevProps) {
    // Debounced autosave: reset the 1.5s timer whenever dirty flips to true
    if (this.props.dirty && !prevProps.dirty) {
      this._scheduleAutosave();
    }
    // If dirty stays true across renders (more edits keep arriving) keep rescheduling
    if (this.props.dirty && prevProps.dirty) {
      this._scheduleAutosave();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._beforeUnload);
    if (this._autosaveTimer) clearTimeout(this._autosaveTimer);
  }

  _scheduleAutosave = () => {
    if (this._autosaveTimer) clearTimeout(this._autosaveTimer);
    this._autosaveTimer = setTimeout(() => {
      this._autosaveTimer = null;
      if (this.props.dirty) {
        this.props.autoSaveMap();
      }
    }, 1500);
  };

  handleBack = () => {
    if (this.props.history) {
      this.props.history.push('/lineage-library');
    } else {
      window.location.href = '/lineage-library';
    }
  };

  render() {
    const {dirty, saveState} = this.props;
    const shouldPrompt = dirty || saveState === 'saving';
    return (
      <div className="app-content-container">
        <Prompt
          when={shouldPrompt}
          message="You have unsaved changes. Leave anyway?"
        />
        <div className="page-content results-container in">
          <LineageEditor
            mapId={this.state.id}
            onBack={this.handleBack}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dirty: state.lineageReducer.dirty,
  saveState: state.lineageReducer.saveState,
});

export default connect(mapStateToProps, {autoSaveMap: A.autoSaveMap})(NewLineage);
